import { errorToast } from "@/v2-ui/toast"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import type { ConfirmButtonProps } from "@/v2-backoffice-client/components/button"
import { useLayerEnableMutation } from "@/v2-backoffice-client/layer/enable/layer.enable.mutation"
import { LAYER_COUNTS_QUERY_NAME } from "@/v2-backoffice-client/layer/counts/layer.counts.constants"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"

export type LayerDisableButtonProps = Omit<ConfirmButtonProps, "onConfirm"> & {
  layer: LayerFragment
}

/**
 * Takes a live layer offline: hides it from all customers and stamps the
 * reviewer, moving it to the Rejected tab until it goes live again. The pair
 * of Go live (LayerReviewPublishButton); neither word is "publish", which the
 * catalog publish owns.
 */
function LayerDisableButton(props: LayerDisableButtonProps) {
  const { layer, children, ...buttonProps } = props

  const [toggle, { loading, error }] = useLayerEnableMutation({
    refetchQueries: [LAYER_COUNTS_QUERY_NAME],
  })
  errorToast(error, { title: "Failed to disable layer" })

  return (
    <ConfirmButton
      variant="warning"
      isStacked
      iconSrc="eye-crossed"
      content="Hide this layer from all customers. It moves to the Rejected tab until it goes live again."
      confirmContent="Hide this layer from all customers?"
      confirmVariant="warning"
      isLoading={loading}
      onConfirm={() => {
        toggle({
          variables: { featureCode: layer.FeatureCode, isEnabled: false },
        })
      }}
      {...buttonProps}
    >
      {children ?? "Take offline"}
    </ConfirmButton>
  )
}

export default LayerDisableButton
